import {
  AccountInterface,
  AttachmentResponseInterface,
  BusinessUnitInterface,
  ChargedWeightDto,
  DeliveryEnum,
  GetShipmentItemsRequestDTO,
  GetTierRequestDto,
  ItemDTO,
  ItemInterface,
  ItemsRateDTO,
  LocationInterface,
  Nullable,
  PaymentModeEnum,
  PaymentModeId,
  PieceInterface,
  ShipmentContentInvoiceInterfaces,
  ShipmentDTO,
  ShipmentInterface,
  ShipmentResponseDto,
  ShipmentResponseSearchDto,
  ShipmentStatusEnum,
  ShipmentTracking,
  ShippingMethodEnum,
  StoreShipmentInterface,
  TierDto,
  TrackingEnum,
  ShipmentPendingAccountStatisticsDto,
  UserInterface,
} from '../interfaces'
import {
  ShipmentMapperDto,
  ShipmentSearchMapperDto,
  mapPaymentModeIdToEnum,
  mapDeliveryTypeIdToEnum,
  mapShipmentStatusIdToEnum,
  mapShipmentDTOToInterface,
} from '../utils/mappers'
import axios from 'axios'
import {
  ListResponse,
  SimpleResponse,
} from '../interfaces/Shipment/ListResponseDto'
import {
  ServiceEnum,
  ShipmentService,
} from '../interfaces/Services/ServicesEnum'
import { store } from '../store/store'
import {
  DeliveryType,
  PaymentMode,
  ShipmentStatus,
} from '../modules/ShipmentV2/filterOptions'
import { apiDjango } from './ApiDjango'
const { REACT_APP_URL_PATH_API } = process.env

export const getUserShipments = async (
  accountCode?: string,
  accountId?: string,
  min: number = 10,
  max?: number,
  search?: string,
  DateFrom?: string,
  DateEnd?: string,
  typeSearch?: number,
): Promise<ShipmentInterface[]> => {
  const response =
    await axios.get(`${REACT_APP_URL_PATH_API}/v2/Shipment/SearchShipmentFilter?accountCode=${
      accountCode ?? ''
    }
  &MaxRow=${max}&Search=${search}&DateFrom=${DateFrom ?? ''}&DateEnd=${
    DateEnd ?? ''
  }&AccountID=${accountId ?? ''}&typeSearch=${typeSearch ?? ''}`)
  if (
    response.status === 200 &&
    !response.data.didError &&
    !!response.data.model
  ) {
    var datamap = response.data.model.map((dto: ShipmentResponseSearchDto) =>
      ShipmentSearchMapperDto(dto),
    )
    return datamap
  }
  return []
}

export const createShipmentApi = async (
  preShipment: ShipmentInterface[],
  files: File[] = [],
): Promise<ShipmentInterface> => {
  let shipmentId = ''
  let shipmentNumber = ''
  let dirError = false
  let errorMessage = ''

  try {
    let datamap = preShipment.map((dto: ShipmentInterface) =>
      ShipmentMapperDto(dto),
    )
    let requestData
    let config = {}
    if (files.length > 0) {
      // Caso con archivos - multipart/form-data
      const formData = new FormData()
      formData.append('shipmentData', JSON.stringify(datamap[0]))

      files.forEach((file) => {
        formData.append('files', file, file.name)
      })

      requestData = formData
      config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    } else {
      // Caso sin archivos - application/json
      requestData = datamap[0]
    }
    await axios
      .post(`${REACT_APP_URL_PATH_API}/v2/Shipment`, requestData, config)
      .then(function (response) {
        var data = response.data as ListResponse<ShipmentResponseDto>
        if (!data.didError) {
          shipmentId = data.model?.shipmentHeaderID ?? ''
          shipmentNumber = data.model?.shipmentNumber ?? ''
        } else {
          errorMessage = data.errorMessage ?? ''
          console.log('Error generando guia:', data.message)
        }
      })
      .catch(function (error) {
        dirError = true
        if (error.response) {
          let errorData = error.response
            .data as ListResponse<ShipmentResponseDto>
          errorMessage = errorData.errorMessage ?? ''
          console.log('Error generando guia:', errorData.errorMessage)
        } else {
          errorMessage = error.message ?? ''
          console.log('Error generando guia:', error.message)
        }
      })
  } catch (error) {
    console.log('Error generando guia:', error)
  }

  return {
    ...preShipment[0],
    id: shipmentId,
    number: Math.floor(100 + Math.random() * 900),
    shipmentNumber: shipmentNumber,
    didError: dirError,
    errorMessage: errorMessage,
    date: new Date().toISOString(),
  }
}
export const createShipmentMasiveApi = async (
  preShipment: ShipmentInterface[],
): Promise<ListResponse<ShipmentResponseDto[]>> => {
  let dirError = false
  let errorMessage = ''
  try {
    let datamap = preShipment.map((dto: ShipmentInterface) =>
      ShipmentMapperDto(dto),
    )
    var response = await axios
      .post(`${REACT_APP_URL_PATH_API}/v2/Shipment/Masive`, { list: datamap })
      .then(function (response) {
        var data = response.data as ListResponse<ShipmentResponseDto>
        if (!data.didError) {
          dirError = false
        } else {
          alert('Error al importar las guias: ' + data.errorMessage)
        }
        return data
      })
      .catch(function (error) {
        dirError = true
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          let errorData = error.response
            .data as ListResponse<ShipmentResponseDto>
          errorMessage = errorData.errorMessage ?? ''
          console.log('Error generando guia:', errorData.errorMessage)

          return errorData
        } else {
          // Something happened in setting up the request that triggered an Error
          errorMessage = error.message ?? ''
          var data = {} as ListResponse<ShipmentResponseDto>
          data.didError = true
          data.errorMessage = 'Error generando guia:' + error.message
          console.log('Error generando guia:', error.message)
          return data
        }

        return error
      })

    return response as ListResponse<ShipmentResponseDto[]>
  } catch (error) {
    console.log('Error generando guia:', error)
  }

  return {} as ListResponse<ShipmentResponseDto[]>
}

export const DowloadShipments = async (
  ShipmentNumber: string,
): Promise<any> => {
  const { token } = store.getState().inmutable
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ShipmentNumber: ShipmentNumber }),
  }
  return fetch(
    `${REACT_APP_URL_PATH_API}/v1/Shipment/DownloadDocumentDeclared`,
    requestOptions,
  )
}

export const DowloadShipmentsPieces = async (
  ShipmentNumber: number,
  serviceId: number,
  buCodeSource: string,
  type: number,
): Promise<any> => {
  const { token } = store.getState().inmutable
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      ShipmentNumber: ShipmentNumber.toString(),
      ServiceID: serviceId.toString(),
      BUCodeSource: buCodeSource.toString(),
      type,
    }),
  }
  return fetch(
    `${REACT_APP_URL_PATH_API}/v1/Shipment/DownloadDocumentPieces`,
    requestOptions,
  )
}

export const DowloadShipmentsMultiples = async (
  ShipmentNumberList: any[],
  url: string,
  type: number,
): Promise<any> => {
  const { token } = store.getState().inmutable
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ List: ShipmentNumberList, type }),
  }
  return fetch(`${REACT_APP_URL_PATH_API}${url}`, requestOptions)
}

export const getShipmentsExists = async (
  shipmentCode: string,
  accountSiteCode?: string,
  accountId?: string,
): Promise<string> => {
  const response = await axios.get(
    `${REACT_APP_URL_PATH_API}/v2/Shipment/SearchShipmentExists?numbersGuides=${shipmentCode}&AccountId=${accountId ?? ''}&AccounSiteCode=${accountSiteCode ?? ''} `,
  )
  if (
    response.status === 200 &&
    !response.data.didError &&
    !!response.data.model
  ) {
    return response.data.model
  }
  return ''
}

export const getShipmentRates = async (
  service: ServiceEnum,
  paymentMode: PaymentModeId,
  deliveryType: DeliveryEnum,
  buCodeConsignee: string,
  sourceLocation: LocationInterface,
  consigneeLocation: LocationInterface,
  items: ItemInterface[],
  pieces: PieceInterface[],
  srm: boolean,
  accountID?: string,
  shipmentAccountId?: string,
): Promise<ListResponse<ItemsRateDTO>> => {
  const uri = `${REACT_APP_URL_PATH_API}/GetShipmentRateV2Async`
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  const body = JSON.stringify({
    srm,
    accountID,
    countryID: 236,
    serviceID: parseInt(service),
    paymentModeID: parseInt(paymentMode),
    deliveryTypeID: parseInt(deliveryType),
    shippingMethodID: 10,
    buCodeConsignee,
    latitudeSource: sourceLocation.coordinates.lat,
    longitudeSource: sourceLocation.coordinates.lng,
    latitudeDestination: consigneeLocation.coordinates.lat,
    longitudeDestination: consigneeLocation.coordinates.lng,
    itemList: items.map((item) => ({
      itemID: item.id,
      itemName: item.name,
    })),
    pieceList: pieces.map((piece) => ({
      weight: piece.weight,
      width: piece.width,
      height: piece.height,
      length: piece.length,
      declaratedValue: piece.declaredValue ?? 0,
    })),
    ShipperAccountID: shipmentAccountId,
  })

  try {
    const response = await axios.post(uri, body, {
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken: source.token,
    })

    if (response.status === 200) {
      return {
        message: '',
        didError: false,
        errorMessage: '',
        model: {
          deliveryDistance: response.data.deliveryDistance,
          pickupDistance: response.data.pickupDistance,
          chargedWeight: response.data.chargedWeight,
          physicalWeight: response.data.physicalWeight,
          dimensionalWeight: response.data.dimensionalWeight,
          items: items.map((item) => {
            const itemRate = response.data.items.find(
              (rate: any) => +rate.itemID === +item.id,
            )
            return {
              ...item,
              // TODO: Refactor mapping to include amounts in base currency and tusd
              rate: {
                value: itemRate ? itemRate.rateResult.amountBaseCurr : 0,
                iva: itemRate ? itemRate.rateResult.itemTaxAmountBaseCurr : 0,
                ipostel: itemRate
                  ? itemRate.rateResult.postalTaxAmountBaseCurr
                  : 0,
                isPercentage: itemRate
                  ? itemRate.rateResult.isPercentage
                  : false,
                distance: itemRate ? itemRate.rateResult.distance : 0,
                tierCode: itemRate ? itemRate.rateTier : '',
                tierName: itemRate ? itemRate.tierName : '',
                pctIva: itemRate ? itemRate.rateResult.pctItemTax : 0,
                ivaAmount: itemRate ? itemRate.rateResult.itemTaxAmount : 0,
                pctIpostel: itemRate ? itemRate.rateResult.pctPostalTax : 0,
                ipostelAmount: itemRate
                  ? itemRate.rateResult.postalTaxAmount
                  : 0,
                valueAmount: itemRate ? itemRate.rateResult.amount : 0,
              },
            }
          }),
        },
      }
    }
  } catch (error) {
    const response = (error as any)?.response?.data

    if (typeof response?.errorMessage === 'string') {
      return response
    }
  }

  return {
    model: null,
    didError: true,
    message: 'Hubo un error al obtener los precios de los servicios.',
    errorMessage: 'Hubo un error al obtener los precios de los servicios.',
  }
}

/**
 * Peso a facturar de un conjunto de piezas (POST /GetChargedWeight, mismo endpoint
 * que usa la Taquilla/Innovus). El backend calcula el peso volumétrico con factores
 * de BD por cuenta/servicio/modo de pago — NO es replicable en el front — y devuelve
 * el mayor entre físico y volumétrico. A diferencia de GetShipmentRateV2Async, no
 * necesita destino ni coordenadas, así que sirve para validar ANTES de cotizar.
 */
export const getChargedWeight = async (
  shipperAccountID: string | undefined,
  accountSiteID: number | undefined,
  serviceID: number | undefined,
  paymentModeID: PaymentModeId | undefined,
  pieces: Pick<PieceInterface, 'weight' | 'height' | 'width' | 'length'>[],
): Promise<SimpleResponse<ChargedWeightDto>> => {
  const uri = `${REACT_APP_URL_PATH_API}/GetChargedWeight`
  const body = JSON.stringify({
    countryID: 236,
    shippingMethodID: 10,
    shipperAccountID,
    accountSiteID,
    serviceID,
    paymentModeID:
      paymentModeID !== undefined ? parseInt(paymentModeID) : undefined,
    pieceList: pieces.map((piece) => ({
      weight: piece.weight,
      width: piece.width,
      height: piece.height,
      length: piece.length,
    })),
  })

  try {
    const response = await axios.post(uri, body, {
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    const response = (error as any)?.response?.data

    if (typeof response?.errorMessage === 'string') {
      return response
    }
  }

  return {
    model: null,
    didError: true,
    message: 'Hubo un error al obtener el peso a facturar.',
    errorMessage: 'Hubo un error al obtener el peso a facturar.',
  }
}

// export const getShipmentItems = async (
//   service: ServiceEnum,
//   paymentMode: PaymentModeId,
//   deliveryType: DeliveryEnum,
//   srm: boolean,
//   shipmentAccountId?: string
// ): Promise<ListResponse<ItemInterface[]>> => {
//   const uri = `${REACT_APP_URL_PATH_API}/SearchItemList?ServiceID=${service}&PaymentModeID=${paymentMode}&DeliveryTypeID=${deliveryType}&SRM=${srm}&ShipperAccountID=${
//     shipmentAccountId ?? ''
//   }`;

//   try {
//     const token = await AuthenticationServices();
//     axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

//     const response = await axios.get(uri);

//     if (response.status === 200) {
//       return {
//         ...response.data,
//         model: response.data.model.map((item: ItemDTO) => ({
//           id: item.itemID.toString(),
//           code: item.itemCode,
//           name: item.itemDescription,
//           order: item.itemOrder,
//           mandatory: item.mandatory,
//           rate: {
//             value: 0,
//             isPercentage: false,
//             tax: 0,
//           },
//         })),
//       };
//     }
//   } catch (error) {
//     return (error as any)?.response?.data;
//   }

//   return {
//     model: null,
//     didError: true,
//     message: 'Hubo un error al obtener los servicios del envío.',
//     errorMessage: 'Hubo un error al obtener los servicios del envío.',
//   };
// };

export const getShipmentItems = async (
  request: GetShipmentItemsRequestDTO,
): Promise<ListResponse<ItemInterface[]>> => {
  const uri = `${REACT_APP_URL_PATH_API}/SearchItemList`
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  const body = JSON.stringify(request)

  try {
    const response = await axios.post(uri, body, {
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken: source.token,
    })

    if (response.status === 200) {
      return {
        ...response.data,
        model: response.data.model.map((item: ItemDTO) => ({
          id: item.itemID.toString(),
          code: item.itemCode,
          name: item.itemDescription.replace(
            '&&',
            Math.abs(item.couponValue ?? 0).toString(),
          ),
          order: item.itemOrder,
          couponID: item.couponID,
          mandatory: item.mandatory,
          isItemBase: item.isItemBase,
          isItemShipment: item.isItemShipment,
          rate: {
            value: 0,
            isPercentage: false,
            tax: 0,
          },
        })),
      }
    }
  } catch (error) {
    return (error as any)?.response?.data
  }

  return {
    model: null,
    didError: true,
    message: 'Hubo un error al obtener los servicios del envío.',
    errorMessage: 'Hubo un error al obtener los servicios del envío.',
  }
}

export const getTier = async (
  request: GetTierRequestDto,
): Promise<ListResponse<TierDto>> => {
  const uri = `${REACT_APP_URL_PATH_API}/GetTier`
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  const body = JSON.stringify(request)

  try {
    const response = await axios.post(uri, body, {
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken: source.token,
    })

    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return (error as any)?.response?.data
  }

  return {
    model: null,
    didError: true,
    message: 'Hubo un error al obtener el tier.',
    errorMessage: 'Hubo un error al obtener el tier.',
  }
}

export const getShipmentTracking = async (
  shipmentNumber: string,
  service: ShipmentService,
  buSourceCode: string,
): Promise<Nullable<ShipmentTracking[]>> => {
  const uri = `${REACT_APP_URL_PATH_API}/Tracking?shipment=${shipmentNumber}&service=${service}&buCodeSource=${buSourceCode}&isDetail=false`
  try {
    const response = await axios.get(uri)

    if (response.status === 200 && response.data[0].tracking.length > 0) {
      return response.data[0].tracking
    }
  } catch (error) {}
  return null
}

export const getShipmentContentInvoice = async (
  shipmentHeaderID: string,
): Promise<ListResponse<ShipmentContentInvoiceInterfaces>> => {
  const uri = `${REACT_APP_URL_PATH_API}/v2/shipment/GetAllShipmentContentInvoice?ShipmentHeaderID=${shipmentHeaderID}`
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()

  try {
    const response = await axios.get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken: source.token,
    })

    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return (error as any)?.response?.data
  }

  return {
    model: null,
    didError: true,
    message: 'Hubo un error al obtener el ShipmentContentInvoice.',
    errorMessage: 'Hubo un error al obtener el ShipmentContentInvoice.',
  }
}

export const searchShipmentFullText = async (
  queryStr: string,
  bUCodeSource?: string,
  bUCodeConsignee?: string,
  shipmentDateFrom?: string,
  shipmentDateTo?: string,
  AccountCode?: string,
  AccountId?: string,
  ManifestNumber?: string,
  ShipmentReference?: string,
  MaxLength?: number,
  statusIDList?: ShipmentStatus[],
  deliveryTypeIDList?: DeliveryType[],
  paymentModeIDList?: PaymentMode[],
  serviceIDList?: ShipmentService[],
  shipmentFilterType?: number,
): Promise<ListResponse<StoreShipmentInterface[]>> => {
  const uri = `${REACT_APP_URL_PATH_API}/v2/Shipment/SearchShipmentsFulltextCCW`

  const body = JSON.stringify({
    queryStr,
    bUCodeSource: bUCodeSource ?? null,
    bUCodeConsignee: bUCodeConsignee ?? null,
    shipmentDateFrom: shipmentDateFrom ?? null,
    shipmentDateTo: shipmentDateTo ?? null,
    AccountCode: AccountCode ?? null,
    AccountId: AccountId ?? null,
    ManifestNumber: ManifestNumber ?? null,
    ShipmentReference: ShipmentReference ?? null,
    MaxLength: MaxLength ?? 1000,
    statusIDList,
    deliveryTypeIDList,
    paymentModeIDList,
    serviceIDList,
    ShipmentFilterTypeList: shipmentFilterType ? [shipmentFilterType] : [],
  })

  try {
    const response = await axios.post(uri, body, {
      headers: {
        'Content-Type': 'application/json',
      },
    })

    return response.data
  } catch (error) {
    return (error as any).response.data
  }
}

export const getShipment = async (
  shipmentNumber: string,
): Promise<Nullable<ShipmentInterface>> => {
  const uri = `${REACT_APP_URL_PATH_API}/v2/Shipment?ShipmentNumber=${shipmentNumber}`

  try {
    const response = await axios.get(uri)
    if (response.status === 200) {
      const dto: ShipmentDTO = response.data.model

      return mapShipmentDTOToInterface(dto)
    }
  } catch (error) {}

  return null
}

export const countSearchShipmentPendingAccount = async (
  accountSiteCode?: string,
  accountId?: string,
): Promise<ListResponse<ShipmentPendingAccountStatisticsDto>> => {
  const uri = `${REACT_APP_URL_PATH_API}/v2/Shipment/CountSearchShipment?accountSiteCode=${
    accountSiteCode ?? ''
  }&accountId=${accountId ?? ''}`

  try {
    const response = await axios.get(uri)
    return response.data as ListResponse<ShipmentPendingAccountStatisticsDto>
  } catch (error) {
    const resp = (error as any)?.response?.data
    if (resp) return resp as ListResponse<ShipmentPendingAccountStatisticsDto>
  }

  return {
    didError: true,
    errorMessage:
      'Hubo un error al consultar CountSearchShipment para la cuenta.',
    message: 'Hubo un error al consultar CountSearchShipment para la cuenta.',
    model: null,
  }
}

export const updateShipmentStatus = async (
  status: ShipmentStatus,
  shipmentId?: string,
  shipmentNumber?: string,
  user?: UserInterface,
  observation?: string,
): Promise<SimpleResponse<boolean>> => {
  const body = JSON.stringify({
    ShipmentHeaderID: shipmentId,
    ShipmentNumber: shipmentNumber,
    StatusID: status,
    UpdateUser: user?.login,
    UpdateDate: new Date().toISOString(),
    Observation: observation,
  })

  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  const uri = `${REACT_APP_URL_PATH_API}/v2/Shipment/Status`

  try {
    const response = await axios.put(uri, body, {
      headers: {
        'Content-Type': 'application/json',
      },
      cancelToken: source.token,
    })

    return response.data
  } catch (error) {}

  return {
    message: '',
    model: null,
    didError: true,
    errorMessage: 'Hubo un error al actualizar la guías',
  }
}

export const getShipmentGuideReport = async (
  customerCode?: string,
  identificationNumber?: string,
  startDate?: string,
  endDate?: string,
  format: 'HTML' | 'PDF' | 'EXCEL' = 'HTML',
): Promise<any> => {
  const response = await axios.get(
    `${REACT_APP_URL_PATH_API}/v2/Shipment/ReportGuide`,
    {
      params: {
        customerCode,
        identificationNumber: customerCode ? '' : (identificationNumber ?? ''),
        startDate: startDate,
        endDate: endDate,
        // Map simplified format to SSRS format if necessary
        format:
          format === 'HTML' ? 'HTML4.0' : format === 'EXCEL' ? 'EXCEL' : format,
      },
      responseType: format === 'HTML' ? 'text' : 'blob',
    },
  )
  return response.data
}

export const getShipmentInternalLabelLaser = async (
  shipmentNumbers: string | number | Array<string | number>,
  format: 'html' | 'pdf' | 'pdf-letter' = 'html',
): Promise<{
  ok: boolean
  content?: string
  labelFormat?: 'HTML' | 'PDF' | 'PDF-LETTER'
  message?: string
  code?: string
  /** El pedido murió por tiempo. La pantalla lo usa para reintentar con menos guías. */
  timedOut?: boolean
}> => {
  const identifications = (
    Array.isArray(shipmentNumbers) ? shipmentNumbers : [shipmentNumbers]
  )
    .map((value) => String(value ?? '').trim())
    .filter((value) => value.length > 0)

  if (identifications.length === 0) {
    return { ok: false, message: 'Shipment number inválido.' }
  }

  const normalizedFormat =
    format === 'pdf' || format === 'pdf-letter' ? format : 'html'

  try {
    const resp = await apiDjango.post<{
      error?: boolean
      message?: string
      code?: string
      data?: { stringLabel?: string; labelFormat?: string }
    }>('/label', {
      shipment_identifications: identifications,
      format: normalizedFormat,
    })

    const payload = resp.data
    const content = payload?.data?.stringLabel
    const labelFormat = payload?.data?.labelFormat

    if (
      payload?.error ||
      typeof content !== 'string' ||
      !content.trim() ||
      (labelFormat !== 'HTML' &&
        labelFormat !== 'PDF' &&
        labelFormat !== 'PDF-LETTER')
    ) {
      return {
        ok: false,
        message: payload?.message ?? 'No se pudo generar la etiqueta.',
        code: payload?.code,
      }
    }

    return {
      ok: true,
      content,
      labelFormat,
      message: payload?.message,
      code: payload?.code,
    }
  } catch (error: any) {
    const payload = error?.response?.data
    return {
      ok: false,
      message: payload?.message ?? labelRequestErrorMessage(error),
      code: payload?.code,
      timedOut: isTimeoutError(error),
    }
  }
}

/**
 * Traduce un fallo de red del pedido de etiquetas a algo accionable.
 *
 * Existe porque el mensaje anterior mentía sobre la causa: interpolaba
 * `error.response.status` y, cuando axios corta por timeout, NO hay `response`, así que
 * el operador leía "Error HTTP  al generar la etiqueta." —sin número, con doble espacio—
 * y lo reportaba como una caída del servidor. En realidad era el `timeout: 30000` de
 * `apiDjango` con demasiadas guías en un mismo pedido, que se arregla bajando el tamaño
 * del grupo, no llamando a soporte.
 */
const labelRequestErrorMessage = (error: any): string => {
  if (isTimeoutError(error)) {
    return 'El servicio tardó demasiado en generar las etiquetas. Prueba seleccionando menos guías.'
  }

  const status = error?.response?.status
  if (status) return `Error HTTP ${status} al generar la etiqueta.`

  return 'No se pudo contactar al servicio de etiquetas. Revisá tu conexión y volvé a intentarlo.'
}

/**
 * ¿El pedido murió por tiempo y no por una respuesta del servidor?
 *
 * Se expone como dato y no solo como texto porque el llamador REACCIONA a esto: al
 * detectarlo, la pantalla vuelve a pedir las etiquetas en grupos más chicos. Un timeout
 * de axios no trae `response`, así que se reconoce por el código o por el mensaje.
 */
export const isTimeoutError = (error: any): boolean =>
  error?.code === 'ECONNABORTED' || /timeout/i.test(error?.message ?? '')

/**
 * Etiqueta ZPL (Zebra) de UNA guía, por Django.
 *
 * Se pide a Django y no al `.NET GetShipmentLabelV2` directo aunque el .NET sea el que
 * termina generando la etiqueta, porque Django resuelve `ServiceID` y `BuCodeSource`
 * **desde la base** antes de reenviar. El llamador solo tiene el nº de guía: el detalle
 * de carga masiva no trae esos dos campos, y sacarlos del `payload_json` da vacío en las
 * filas que no fijaron oficina origen (ver `printFieldsFromPayload`), lo que produciría
 * una etiqueta equivocada en silencio.
 *
 * De paso, este camino sí evalúa al usuario (`get_object_access_q` + `SHIPMENT_LABEL`) y
 * devuelve un error con nombre cuando a la guía le falta servicio u oficina, en vez de
 * imprimir mal.
 *
 * `formatType`: 0 = Zebra 10x6 (incluye servicio y tienda), 1 = Zebra 10x10 (estándar).
 * Son los mismos valores que ya usa la impresión de consulta.
 *
 * Acepta id, nº de guía o nº de guía aliada como identificación.
 */
export const getShipmentZebraLabel = async (
  shipmentIdentification: string,
  formatType: 0 | 1,
): Promise<{
  ok: boolean
  stringLabel?: string[]
  labelFormat?: string
  message?: string
  code?: string
}> => {
  const identification = String(shipmentIdentification ?? '').trim()
  if (!identification) {
    return { ok: false, message: 'Número de guía inválido.' }
  }

  // REGLA (spec §6.2): nunca ramificar por status HTTP; el backend responde 200 incluso
  // en errores de negocio. Se mira `error`/`code`/`message` del envelope.
  try {
    const resp = await apiDjango.get<{
      error?: boolean
      message?: string
      code?: string
      data?: { stringLabel?: unknown; labelFormat?: unknown }
    }>(
      `/shipment/${encodeURIComponent(identification)}/label?format_type=${formatType}`,
    )

    const payload = resp.data
    const stringLabel = payload?.data?.stringLabel
    const labelFormat = payload?.data?.labelFormat

    if (payload?.error) {
      return {
        ok: false,
        message: payload?.message ?? 'No se pudo generar la etiqueta.',
        code: payload?.code,
      }
    }

    // El servicio externo puede responder OK con la lista vacía: sin ZPL no hay nada que
    // mandarle a la impresora, así que eso es un fallo, no un éxito silencioso.
    if (
      !Array.isArray(stringLabel) ||
      stringLabel.length === 0 ||
      !stringLabel.every((s) => typeof s === 'string')
    ) {
      return {
        ok: false,
        message:
          payload?.message ??
          'El servicio no devolvió ninguna etiqueta para la guía.',
        code: payload?.code,
      }
    }

    return {
      ok: true,
      stringLabel: stringLabel as string[],
      labelFormat: typeof labelFormat === 'string' ? labelFormat : '',
      message: payload?.message,
      code: payload?.code,
    }
  } catch (error: any) {
    const payload = error?.response?.data
    return {
      ok: false,
      // Mismo traductor que el pedido por lote: `error.message` crudo devolvía cosas
      // como "timeout of 30000ms exceeded", que el operador no puede accionar.
      message: payload?.message ?? labelRequestErrorMessage(error),
      code: payload?.code ?? 'network',
    }
  }
}
